import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "../contexts/ProtectedRoute";
import Landing from "../pages/Landing";
import Signup from "../pages/auth/Signup";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import Sidebar from "../layout/SideBar";
import TopBar from "../layout/TopBar";
import Bookings from "../pages/bookings/ListBookings";
import ViewBookingPage from "../pages/bookings/ViewBooking";
import AddBooking from "../pages/bookings/AddBooking";
import { Box } from "@mui/material";
import Home from "../pages/stream-management/ListStreams";
import Venues from "../pages/venues/ListVenues";
import Contacts from "../pages/contacts/ListContacts";
import AddCompany from "../pages/contacts/components/AddCompanyContact";
import AddIndividual from "../pages/contacts/components/AddIndividualContact";
import CompanyView from "../pages/contacts/components/CompanyContactView";
import IndividualView from "../pages/contacts/components/IndividualContactView";
import EditCompany from "../pages/contacts/components/EditCompanyContact";
import EditIndividual from "../pages/contacts/components/EditIndividualContact";
import Equipment from "../pages/gear-management/ListEquipment";
import Settings from "../pages/settings/Home";
import Configurations from "../pages/configurations/Configurations";
import Sales from "../pages/sales/Home";
import Changelog from "../layout/ChangeLog";
import AddVenue from "../pages/venues/AddVenue";
import ViewVenue from "../pages/venues/ViewVenue";
import EditVenue from "../pages/venues/EditVenue";
import TenDayForecast from "../pages/stream-management/TenDayForecast";
import AddStream from "../pages/stream-management/AddStream";
import EditStream from "../pages/stream-management/EditStream";
import EditBooking from "../pages/bookings/EditBooking";
// import ViewStream from "../pages/stream-management/ViewStream";
import PackageData from "../pages/configurations/packages/PackageData";
import "../App.css";
// import { PilotReviews } from "../pages/crew-management/tabs/reviews";
import Availability from "../pages/crew-management/tabs/Availability";
// import MemorialPage from "../pages/stream-management/components/memorial-page/MemorialPage";
import CrewManagement from "../pages/crew-management/CrewDashboard";
import AllCrew from "../pages/crew-management/AllCrew";
import ViewCrewMember from "../pages/crew-management/ViewCrewMember";
import Checklists from "../pages/crew-management/Checklists";
import ViewChecklist from "../pages/crew-management/ViewChecklist";
import CrewRatings from "../pages/crew-management/CrewRatings";
import CrewRates from "../pages/crew-management/CrewRates";
import Setup2FA from "../pages/auth/Setup2FA";
import Verify2FA from "../pages/auth/Verify2FA";
import MemoryTableComponent from "../pages/stream-management/components/memory-table/MemoryTableListing";
import MemoryTableView2 from "../pages/stream-management/components/memory-table/MemoryTableView2";
import PixelPilotApplicationForm from "../pages/stream-management/components/PixelPilotApplicationForm";
import StreamReport from "../pages/stream-management/components/StreamReport";
import ChurchBookingForm from "../pages/bookings/components/ChurchBookingForm";
import TemplateManager from "../pages/configurations/thumbnails/TemplateManager";
import TableTentPrintPage from "../pages/stream-management/components/TableTent";
import CallSheetLayout from "../pages/stream-management/components/callsheet/CallSheetPage";
import UserManagement from "../pages/users-admin/UserManagement";
import UserProfile from "../pages/users-admin/UserProfile";
import CoursesList from "../pages/lms/CoursesList";
import RolesPermissions from "../pages/configurations/roles/RolesPermissions";
import MemorialPage from "../pages/stream-management/components/memorial-page/MemorialPage";
import SiteVisitList from "../pages/site-visit/SiteVisitList";
import ViewStream from "../pages/stream-management/ViewStream";
import MainDashboard from "../pages/dashboard/DashboardPage";
import BulkCrewAssignment from "../pages/callsheet/BulkCreateCallsheet";
import ClientAdminDashboard from "../pages/client-portal-admin/ClientMemorialDashboard";
import ProposalBuilde from "../pages/proposal/proposal-builder/ProposalBuilder";
import { ProposalDashboards } from "../pages/proposal/proposal-dashboard/ProposalDashboard";
import ViewMemorialPage from "../pages/client-portal-admin/ViewMemorialPages";
import CoverProposalTemplate from "../pages/configurations/cover-proposal-templates/CoverProposalTemplate";
import ShareMessageConfiguration from "../pages/configurations/share-messages/ShareMessageConfig";
import ServiceQuoteForm from "../pages/proposal/service-quote-form/ServiceQuoteForm";
import DashboardOverview from "../pages/lms/overview/DashboardOverview";
import CourseManagement from "../pages/lms/courses/CoursesManagement";
import CreateCourseForm from "../pages/lms/courses/CreateCourseForm";
import Assessments from "../pages/lms/assessments/Assessment";
import BadgesAndCertificates from "../pages/lms/badges/Badges";
import CourseView from "../pages/lms/courses/courses-viewer/CourseView";
import ServiceQuotation from "../pages/proposal/quotations/Quotation";
import AutoLogPage from "../pages/autolog/AutologPage";
import RequestedQuotesDashboard from "../pages/proposal/quotations/QuoteRequestDashboard";
import QuoteRequestView from "../pages/proposal/quotations/QuoteRequestView";
import ChemaForm from "../pages/stream-management/components/memorial-page/components/chema/Form";
import Insights from "../pages/chema/Insights";
import ViewChecklistItems from "../pages/crew-management/checklists/ViewChecklistItems";
import EndpointRequestsPage from "../pages/endpoint-requests/EndpointRequestsPage";
import EmployeeProfilePage from "../pages/autolog/components/EmployeeProfilePage/EmployeeProfilePage";
import IntroductionLetterConfiguration from "../pages/configurations/introduction-letter-templates/IntroductionLetter";
import VenuesWidgetAdmin from "../pages/configurations/venues-admin-config/VenuesWidgetsAdmin";

// Layout component for authenticated routes
const AuthLayout: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100vw",
        m: 0,
        p: 0,
        flexDirection: "column",
      }}
    >
      <TopBar />
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          width: "100%",
          height: "calc(100vh - 64px)",
        }}
      >
        <Sidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            m: 2,
            p: 2,
            boxSizing: "border-box",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

const AppRoutes: React.FC = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 10001 }}
      />
      <Routes>
        {/* Non-authenticated routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/:pageType/:id/:fullName" element={<MemorialPage />} />
        <Route path="/:pageType/:id/:fullName/chema" element={<ChemaForm />} />

        <Route path="/login" element={<Login />} />

        <Route path="/setup-2fa" element={<Setup2FA />} />
        <Route path="/verify-2fa" element={<Verify2FA />} />
        <Route
          path="/pixel-pilot-application-form"
          element={<PixelPilotApplicationForm />}
        />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* <Route path="/reviews" element={<Reviews />} /> */}
        <Route path="/availability" element={<Availability />} />
        <Route
          path="/reset-password/:uidb64/:token"
          element={<ResetPassword />}
        />

        <Route path="/funeral-quote" element={<ServiceQuoteForm />} />

        {/* Authenticated routes with layout */}
        <Route element={<AuthLayout />}>
          <Route
            path="/chema/insights"
            element={
              <ProtectedRoute>
                <Insights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <MainDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management/view/:id"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/manage-roles"
            element={
              <ProtectedRoute>
                <RolesPermissions />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/user-management/edit-user"
            element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/bookings"
            element={
              <ProtectedRoute>
                <Bookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/church"
            element={
              <ProtectedRoute>
                {" "}
                <Bookings
                  bookingType="CHURCH"
                  title="Church Bookings"
                  defaultServiceType="CHURCH"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/funeral"
            element={
              <ProtectedRoute>
                <Bookings
                  bookingType="FUNERAL"
                  title="Funeral Bookings"
                  defaultServiceType="FUNERAL"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/funeral-home"
            element={
              <ProtectedRoute>
                <Bookings
                  bookingType="FUNERAL_HOME"
                  title="Funeral Home Bookings"
                  defaultServiceType="FUNERAL_HOME"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/other"
            element={
              <ProtectedRoute>
                <Bookings
                  bookingType="OTHER"
                  title="Other Bookings"
                  defaultServiceType="OTHER"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/conference"
            element={
              <ProtectedRoute>
                <Bookings
                  bookingType="CONFERENCE"
                  title="Conference Bookings"
                  defaultServiceType="CONFERENCE"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/event"
            element={
              <ProtectedRoute>
                <Bookings
                  bookingType="EVENT"
                  title="Event bookings"
                  defaultServiceType="EVENT"
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/:id"
            element={
              <ProtectedRoute>
                <ViewBookingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/:id/edit"
            element={
              <ProtectedRoute>
                <EditBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bookings/add/:serviceType"
            element={
              <ProtectedRoute>
                <AddBooking />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/add"
            element={
              <ProtectedRoute>
                <AddStream />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/view/:id"
            element={
              <ProtectedRoute>
                <ViewStream />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/view/:id/stream-report"
            element={
              <ProtectedRoute>
                <StreamReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/view/:id/callsheet"
            element={
              <ProtectedRoute>
                <CallSheetLayout />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/view/:id/edit"
            element={
              <ProtectedRoute>
                <EditStream />
              </ProtectedRoute>
            }
          />
          <Route
            path="/venues"
            element={
              <ProtectedRoute>
                <Venues />
              </ProtectedRoute>
            }
          />
          <Route
            path="/venues/add"
            element={
              <ProtectedRoute>
                <AddVenue />
              </ProtectedRoute>
            }
          />
          <Route
            path="/venues/view/:id"
            element={
              <ProtectedRoute>
                <ViewVenue />
              </ProtectedRoute>
            }
          />
          {/* <Route
          path ="/add-member"
          element={
            <ProtectedRoute>
              <UserForm/>
              </ProtectedRoute>

          }
          /> */}
          <Route
            path="venues/view/:id/edit"
            element={
              <ProtectedRoute>
                <EditVenue />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <ProtectedRoute>
                <Contacts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <ProtectedRoute>
                <Contacts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/add-company-contact"
            element={
              <ProtectedRoute>
                <AddCompany />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/add-individual"
            element={
              <ProtectedRoute>
                <AddIndividual />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/company/view/:id"
            element={
              <ProtectedRoute>
                <CompanyView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/view/:id/table-tent"
            element={
              <ProtectedRoute>
                <TableTentPrintPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/individual/view/:id"
            element={
              <ProtectedRoute>
                <IndividualView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/company/edit/:id"
            element={
              <ProtectedRoute>
                <EditCompany />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contacts/individual/edit/:id"
            element={
              <ProtectedRoute>
                <EditIndividual />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management"
            element={
              <ProtectedRoute>
                <CrewManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/all-crew"
            element={
              <ProtectedRoute>
                <AllCrew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/checklists"
            element={
              <ProtectedRoute>
                <Checklists />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/checklists/:id"
            element={
              <ProtectedRoute>
                <ViewChecklist />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/crew-ratings"
            element={
              <ProtectedRoute>
                <CrewRatings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/rates"
            element={
              <ProtectedRoute>
                <CrewRates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/crew-management/view/:id"
            element={
              <ProtectedRoute>
                <ViewCrewMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gear-management"
            element={
              <ProtectedRoute>
                <Equipment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations"
            element={
              <ProtectedRoute>
                <Configurations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/autolog"
            element={
              <ProtectedRoute>
                <AutoLogPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/autolog/:employeeId"
            element={
              <ProtectedRoute>
                <EmployeeProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <ProtectedRoute>
                <Sales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/changelog"
            element={
              <ProtectedRoute>
                <Changelog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memory-table"
            element={
              <ProtectedRoute>
                <MemoryTableComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memory-table/view/:id"
            element={
              <ProtectedRoute>
                <MemoryTableView2 />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/ten-day-forecast"
            element={
              <ProtectedRoute>
                <TenDayForecast />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/thumbnail-template-manager"
            element={
              <ProtectedRoute>
                <TemplateManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/package"
            element={
              <ProtectedRoute>
                <PackageData />
              </ProtectedRoute>
            }
          />

          <Route
            path="/configurations/venues-admin"
            element={
              <ProtectedRoute>
                <VenuesWidgetAdmin />
              </ProtectedRoute>
            }
          />

          <Route
            path="/bookings/:id/church-form"
            element={
              <ProtectedRoute>
                <ChurchBookingForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="muzukuru-academy"
            element={
              <ProtectedRoute>
                <CoursesList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/site-visit"
            element={
              <ProtectedRoute>
                {" "}
                <SiteVisitList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals"
            element={
              <ProtectedRoute>
                <ProposalDashboards />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposals/proposals-builder"
            element={
              <ProtectedRoute>
                <ProposalBuilde />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bulk-crew-assignment"
            element={
              <ProtectedRoute>
                {" "}
                <BulkCrewAssignment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memorial-pages"
            element={
              <ProtectedRoute>
                {" "}
                <BulkCrewAssignment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-portal-dashboard"
            element={
              <ProtectedRoute>
                {" "}
                <ClientAdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/client-portal-dashboard/:id"
            element={
              <ProtectedRoute>
                {" "}
                <ViewMemorialPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/proposal-cover-page"
            element={
              <ProtectedRoute>
                {" "}
                <CoverProposalTemplate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/share-messages"
            element={
              <ProtectedRoute>
                {" "}
                <ShareMessageConfiguration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stream-management/ten-day-forecast"
            element={
              <ProtectedRoute>
                {" "}
                <TenDayForecast />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/overview"
            element={
              <ProtectedRoute>
                {" "}
                <DashboardOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses"
            element={
              <ProtectedRoute>
                {" "}
                <CourseManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:id"
            element={
              <ProtectedRoute>
                {" "}
                <CourseView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/create-course"
            element={
              <ProtectedRoute>
                {" "}
                <CreateCourseForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assessments"
            element={
              <ProtectedRoute>
                {" "}
                <Assessments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/badges"
            element={
              <ProtectedRoute>
                {" "}
                <BadgesAndCertificates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proposal/service-quotation"
            element={
              <ProtectedRoute>
                {" "}
                <ServiceQuotation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-for-quote"
            element={
              <ProtectedRoute>
                {" "}
                <RequestedQuotesDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/request-for-quote/:id"
            element={
              <ProtectedRoute>
                {" "}
                <QuoteRequestView />
              </ProtectedRoute>
            }
          />

          <Route
            path="/checklists/:checklistId/sections/:sectionId"
            element={
              <ProtectedRoute>
                {" "}
                <ViewChecklistItems />
              </ProtectedRoute>
            }
          />
          <Route
            path="/endpoint-requests"
            element={
              <ProtectedRoute>
                <EndpointRequestsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configurations/proposal-introduction-letter"
            element={
              <ProtectedRoute>
                <IntroductionLetterConfiguration />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
